export enum ActivityCallType {
  TYPE_RECEIVEPHONE = 30,
  TYPE_RECEIVEVOICEMAIL = 31,
  TYPE_DIALPHONE = 32,
  TYPE_LEAVEVOICEMAIL = 33,
  TYPE_NOVOICEMAILAVAILABLE = 34,
}

export interface ActivityActor {
  actor_id: number;
  actor_scope_key: 'cipxaccountuser' | 'xbadmin' | string;
  actor_full_name: string;
  actor_first_name: string;
  actor_last_name: string;
  actor_initials: string;
}

export interface RelatedQuoteRequestRef {
  quote_request_id: number;
  order_number?: string;
  label?: string;
  user_id?: number;
  company_name?: string;
  bond_amount?: number;
  state_abbreviation?: string;
  surety_bond_label?: string;
}

export interface ActivityCallFormDraft {
  eventTypeId: ActivityCallType;
  subject: string;
  notes: string;
  actors: ActivityActor[];
  relatedRequests: RelatedQuoteRequestRef[];
  createFollowUpTask?: boolean;
}

export interface QuoteRequestEventLogActivityInfo {
  actors: ActivityActor[];
  notes: string;
  related_quote_requests: RelatedQuoteRequestRef[];
}

export interface QuoteRequestEventLogInfo {
  activity?: QuoteRequestEventLogActivityInfo;
  [key: string]: unknown;
}

export interface QuoteRequestEventLog {
  event_log_id?: number;
  event_log_type_id: number;
  event_log_time?: string;
  event_log_admin_id?: number | null;
  event_log_admin_user_first_name?: string | null;
  event_log_admin_user_last_name?: string | null;
  event_log_user_id?: number | null;
  event_log_comment: string;
  event_log_exception?: string;
  ctime?: string;
  event_log_info: QuoteRequestEventLogInfo | null;
  quote_request_id: number | null;
  order_number?: string;
  account_id?: number | null;
  event_log_source?: string;
  event_log_account_id?: number | null;
  event_log_account_user_id?: number | null;
  event_log_lead_id?: number | null;
  is_alias?: boolean;
}

export interface CreateCallActivityEventLogInput {
  quoteRequestId: number | null;
  accountId: number | null;
  accountUserId: number | null;
  adminUserId: number | null;
  eventTypeId: ActivityCallType;
  subject: string;
  notes: string;
  actors: ActivityActor[];
  relatedRequests: RelatedQuoteRequestRef[];
}
